import type { FC } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useIsMobileVariant } from '@dhl-ui/components'

import { links } from '~/links.js'
import { SearchButton } from '../search-button/SearchButton.js'
import { DesktopSearch } from '../DesktopSearch.js'
import { useSearchStore } from '~/search/model/useSearchStore.js'

export const SearchControl: FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const isMobile = useIsMobileVariant()

  const { setOrigin } = useSearchStore()

  const handleMobileSearchClick = () => {
    setOrigin(pathname)

    navigate(links.searchResultsLink(), {
      state: {
        referrer: pathname,
      },
    })
  }

  return isMobile ? <SearchButton onClick={handleMobileSearchClick} /> : <DesktopSearch />
}
